<script>
import { api } from "@/state/services";
import ModalPayment from "@/components/_exclusaoindividual/modal-payment";
import ModalDel from "@/components/_exclusaoindividual/modal-del";
import ModalDocumentsSend from "@/components/_exclusaoindividual/modal-documents-send";
import DocumentRow from "@/components/_exclusaoindividual/document-row";

export default {
  components: {
    ModalPayment,
    ModalDel,
    ModalDocumentsSend,
    DocumentRow,
  },
  props: {
    modal: {
      type: Boolean,
      default: false,
    },
    client: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      // Documentos e acesso do cliente ainda não estão liberados na interface
      documentsEnabled: true,

      documents: {
        loading: false,
        list: null,
        upload: {
          // Tipo de documento com upload em andamento — trava só a própria linha
          type: "",
        },
        send: {
          modal: false,
          type: "",
        },
      },

      agencies: {
        loading: false,
        serasa: false,
        spc: false,
        boaVista: false,
        cenprot: false,
      },

      // Órgãos negativados na ordem de exibição — cada um tem seu comprovante
      agencyList: [
        { key: "serasa",   type: "agency_serasa",     label: "Serasa" },
        { key: "spc",      type: "agency_spc",        label: "SPC" },
        { key: "boaVista", type: "agency_boa_vista",  label: "Boa Vista" },
        { key: "cenprot",  type: "agency_cenprot",    label: "Cenprot" },
      ],

      payment: {
        modal: false,
      },

      del: {
        modal: false,
      },
    };
  },
  computed: {
    show: {
      get() {
        return this.modal;
      },
      set(value) {
        this.$emit("update:modal", value);
      },
    },
    // Tipos que pertencem aos órgãos — usados para separar as duas listas
    agencyTypes() {
      return this.agencyList.map((agency) => agency.type);
    },
    // Documentos fixos do cliente (ficha, autorização, doc com foto, CNPJ...)
    mainDocuments() {
      if (!this.documents.list) {
        return [];
      }
      return this.documents.list.filter((doc) => !this.agencyTypes.includes(doc.type));
    },
    /**
     * Todos os órgãos, casados com o comprovante vindo da API. Os desligados
     * continuam na lista (a linha só fica inativa) e, enquanto o servidor não
     * devolve o documento, a linha usa o placeholder 'pending'.
     */
    agencyDocuments() {
      const list = this.documents.list || [];

      return this.agencyList.map((agency) => ({
        ...agency,
        doc: list.find((doc) => doc.type === agency.type) || { status: "pending" },
      }));
    },
  },
  methods: {
    onShow() {
      this.agencies.serasa = !!this.client.agencySerasa;
      this.agencies.spc = !!this.client.agencySpc;
      this.agencies.boaVista = !!this.client.agencyBoaVista;
      this.agencies.cenprot = !!this.client.agencyCenprot;

      if (!this.documentsEnabled) {
        return;
      }

      this.documents.list = null;
      this.documents.loading = false;
      this.getDocuments();
    },
    /**
     * Desmarcar um órgão apaga o comprovante já enviado — confirma antes e
     * desfaz a marcação se o consultor desistir.
     */
    onAgencyChange(agency, checked) {
      const doc = (this.documents.list || []).find((item) => item.type === agency.type);

      if (checked || !doc || !doc.id) {
        this.saveAgencies();
        return;
      }

      this.$bvModal
        .msgBoxConfirm(`O comprovante enviado para ${agency.label} será excluído. Deseja continuar?`, {
          title: 'Remover órgão',
          okTitle: 'Sim, remover',
          cancelTitle: 'Cancelar',
          okVariant: 'danger',
          centered: true,
        })
        .then((confirmed) => {
          if (confirmed) {
            this.saveAgencies();
          } else {
            this.agencies[agency.key] = true;
          }
        });
    },
    saveAgencies() {
      this.agencies.loading = true;
      api
        .post('exclusaoindividual/clients/agencies', {
          id: this.client.id,
          agencySerasa: this.agencies.serasa,
          agencySpc: this.agencies.spc,
          agencyBoaVista: this.agencies.boaVista,
          agencyCenprot: this.agencies.cenprot,
        })
        .then((response) => {
          this.agencies.loading = false;
          if (response.data.status === 'success') {
            this.$toast.success(response.data.message);
            this.$emit('reload');
            this.getDocuments();
          } else {
            this.$toast.error(response.data.message);
          }
        })
        .catch(() => {
          this.agencies.loading = false;
        });
    },
    getDocuments() {
      this.documents.loading = true;
      api
        .get('exclusaoindividual/clients/documents/' + this.client.id)
        .then((response) => {
          if (response.data.status === 'success') {
            this.documents.list = response.data.documents;
          }
          this.documents.loading = false;
        })
        .catch(() => {
          this.documents.loading = false;
        });
    },
    uploadDocument(type, event) {
      const file = event.target.files[0];
      if (!file) return;
      this.documents.upload.type = type;
      const formData = new FormData();
      formData.append('file', file);
      api
        .post(`exclusaoindividual/clients/documents/upload/${this.client.id}/${type}`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        })
        .then((response) => {
          if (response.data.status === 'success') {
            this.$toast.success('Documento enviado com sucesso!');
            this.getDocuments();
          } else {
            this.$toast.error(response.data.message);
          }
          this.documents.upload.type = '';
          event.target.value = '';
        })
        .catch(() => {
          this.documents.upload.type = '';
        });
    },
    copyLink(url) {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(url)
          .then(() => this.$toast.success('Link copiado!'))
          .catch(() => this.$toast.error('Não foi possível copiar.'));
      }
    },
    docLabel(type) {
      const labels = {
        ficha_associativa:   'Ficha Associativa',
        autorizacao_processo:'Autorização de Processo',
        contrato_social:     'Contrato Social',
        cartao_cnpj:         'Cartão CNPJ',
        doc_foto:            this.client.type == 'natural' ? 'Documento com Foto' : 'Documento com Foto do Sócio',
        agency_serasa:       'Serasa',
        agency_spc:          'SPC',
        agency_boa_vista:    'Boa Vista',
        agency_cenprot:      'Cenprot',
      };
      return labels[type] || type;
    },
    isSignType(type) {
      return ['ficha_associativa', 'autorizacao_processo'].includes(type);
    },
    // Força o ciclo false → true para o modal abrir mesmo se a flag ficou dessincronizada
    openModal(target) {
      target.modal = false;

      this.$nextTick(() => {
        target.modal = true;
      });
    },
    showPayment() {
      this.openModal(this.payment);
    },
    showDel() {
      this.openModal(this.del);
    },
    showSendDocument(type) {
      this.documents.send.type = type;
      this.openModal(this.documents.send);
    },
    onPaid() {
      this.show = false;
      this.$emit('reload');
    },
    onDeleted() {
      this.show = false;
      this.$emit('reload');
    },
  },
};
</script>

<template>
  <div>
    <b-modal v-model="show" title="Dados do Cliente" modal-class="modal-right" hide-footer @show="onShow">
      <div>
        <div class="mb-3"><strong class="font-size-12">Criado em {{ client.date_added }}</strong></div>
      </div>
      <div class="mb-3" v-if="client.refazer_status == 'new'">
        <span class="badge badge-soft-info p-2 font-size-14">REFAZER</span>
      </div>
      <template v-if="client.type == 'natural'">
        <div class="mb-3"><strong class="font-size-12">Nome</strong><br><span class="font-size-16">{{ client.name }}</span></div>
        <div class="mb-3"><strong class="font-size-12">CPF</strong><br><span class="font-size-16">{{ client.person_number }}</span></div>
      </template>
      <template v-else>
        <div class="mb-3"><strong class="font-size-12">Razão Social</strong><br><span class="font-size-16">{{ client.name }}</span></div>
        <div class="mb-3"><strong class="font-size-12">CNPJ</strong><br><span class="font-size-16">{{ client.person_number }}</span></div>
        <div class="mb-3"><strong class="font-size-12">Nome do Sócio</strong><br><span class="font-size-16">{{ client.company_partner_name }}</span></div>
        <div class="mb-3"><strong class="font-size-12">CPF do Sócio</strong><br><span class="font-size-16">{{ client.company_partner_cpf }}</span></div>
      </template>
      <div class="mb-3"><strong class="font-size-12">Email</strong><br><span class="font-size-16">{{ client.email }}</span></div>
      <div class="mb-3"><strong class="font-size-12">Celular</strong><br><span class="font-size-16">{{ client.cellphone }}</span></div>
      <div class="mb-3">
        <strong class="font-size-12">Endereço</strong><br>
        <span class="font-size-16">
          {{ client.address }}, {{ client.number }}<template v-if="client.complement">, {{ client.complement }}</template><br>
          {{ client.district }} - {{ client.city }}/{{ client.state }}<br>
          {{ client.zipcode }}
        </span>
      </div>
      <div class="mb-3">
        <strong class="font-size-12">Status</strong><br>
        <span class="badge badge-soft-danger p-2 font-size-14" v-if="client.status == 'pending'">PENDENTE</span>
        <template v-else-if="client.status == 'approved'">
          <span class="badge badge-soft-success p-2 mb-1 mr-1 font-size-14">PAGO</span>
          <span class="font-size-14 text-center">{{ client.date_approved }}</span>
        </template>
      </div>
      <div class="mb-3" v-if="client.observations">
        <strong class="font-size-12">Observações</strong><br>
        <fieldset v-html="client.observations">
        </fieldset>
      </div>

      <div v-if="documentsEnabled" class="mb-3">
        <fieldset class="py-0">
          <legend>Documentos</legend>
          <div v-if="documents.loading" class="text-center py-3">
            <b-spinner variant="default" small role="status"></b-spinner>
          </div>
          <div v-else-if="documents.list">
            <DocumentRow
              v-for="(doc, index) in mainDocuments"
              :key="doc.type"
              :doc="doc"
              :label="docLabel(doc.type)"
              :busy="documents.upload.type === doc.type"
              :sign-type="isSignType(doc.type)"
              :border="index < mainDocuments.length - 1"
              @upload="uploadDocument(doc.type, $event)"
              @generate="showSendDocument(doc.type)"
              @copy="copyLink(doc.sign_url)"
            />
          </div>
        </fieldset>
      </div>

      <div class="mb-3">
        <fieldset class="py-0">
          <legend>
            Órgãos Negativados
            <b-spinner v-if="agencies.loading" small class="ml-2 align-middle" role="status"></b-spinner>
          </legend>
          <DocumentRow
            v-for="(agency, index) in agencyDocuments"
            :key="agency.type"
            :doc="agency.doc"
            :busy="documents.upload.type === agency.type || agencies.loading"
            :disabled="!agencies[agency.key]"
            :border="index < agencyDocuments.length - 1"
            @upload="uploadDocument(agency.type, $event)"
          >
            <b-form-checkbox
              switch
              v-model="agencies[agency.key]"
              :disabled="agencies.loading"
              class="font-size-13"
              @change="onAgencyChange(agency, $event)"
            >
              {{ agency.label }}
            </b-form-checkbox>
          </DocumentRow>
        </fieldset>
      </div>

      <div class="mt-3">
        <button class="btn btn-success btn-lg btn-block" :disabled="client.status != 'pending'" v-on:click="showPayment()">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: currentColor">
            <path
              d="M12 15c-1.84 0-2-.86-2-1H8c0 .92.66 2.55 3 2.92V18h2v-1.08c2-.34 3-1.63 3-2.92 0-1.12-.52-3-4-3-2 0-2-.63-2-1s.7-1 2-1 1.39.64 1.4 1h2A3 3 0 0 0 13 7.12V6h-2v1.09C9 7.42 8 8.71 8 10c0 1.12.52 3 4 3 2 0 2 .68 2 1s-.62 1-2 1z">
            </path>
            <path d="M5 2H2v2h2v17a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V4h2V2H5zm13 18H6V4h12z"></path>
          </svg>
          Realizar Pagamento
        </button>
      </div>
      <div class="mt-3">
        <button class="btn btn-danger btn-lg btn-block" :disabled="client.status != 'pending'" v-on:click="showDel()">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: currentColor">
            <path d="M5 20a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8h2V6h-4V4a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2v2H3v2h2zM9 4h6v2H9zM8 8h9v12H7V8z"></path>
            <path d="M9 10h2v8H9zm4 0h2v8h-2z"></path>
          </svg>
          Excluir Cliente
        </button>
      </div>
    </b-modal>

    <ModalPayment :modal.sync="payment.modal" :client="client" @paid="onPaid" />

    <ModalDel :modal.sync="del.modal" :id="client.id" @deleted="onDeleted" />

    <ModalDocumentsSend :modal.sync="documents.send.modal" :client="client" :type="documents.send.type" @sent="getDocuments" />
  </div>
</template>

<style scoped>
button:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}
</style>
